/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_All_EventsInputs */

const en_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Events`)
};

const de_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Events`)
};

const es_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los eventos`)
};

const fr_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les évènements`)
};

const nl_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Events`)
};

const it_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti gli eventi`)
};

const pt_br2_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os eventos`)
};

const pl_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie wydarzenia`)
};

const hu_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden esemény`)
};

const ro_admin_dashboard_all_events = /** @type {(inputs: Admin_Dashboard_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate Evenimentele`)
};

/**
* | output |
* | --- |
* | "All Events" |
*
* @param {Admin_Dashboard_All_EventsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_all_events = /** @type {((inputs?: Admin_Dashboard_All_EventsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_All_EventsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_all_events(inputs)
	if (locale === "de") return de_admin_dashboard_all_events(inputs)
	if (locale === "es") return es_admin_dashboard_all_events(inputs)
	if (locale === "fr") return fr_admin_dashboard_all_events(inputs)
	if (locale === "nl") return nl_admin_dashboard_all_events(inputs)
	if (locale === "it") return it_admin_dashboard_all_events(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_all_events(inputs)
	if (locale === "pl") return pl_admin_dashboard_all_events(inputs)
	if (locale === "hu") return hu_admin_dashboard_all_events(inputs)
	return ro_admin_dashboard_all_events(inputs)
});
export { admin_dashboard_all_events as "admin.dashboard.all_events" }